"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapSubscriptionBenefitBanner = exports.mapSubscription = exports.mapShades = exports.mapProductsFromGql = exports.mapProductFromGql = exports.mapProductDiscontinuedAndCannotBeSold = exports.mapProductBase = exports.mapGroupedProducts = exports.getProductSize = void 0;
var _productBox = require("@ori/product-box");
var _entities = require("entities");
const getProductSize = ({
  volumeValue,
  volumeUnitText
}) => {
  if (volumeValue != null && volumeUnitText != null) {
    return `${volumeValue} ${volumeUnitText.trim()}`;
  }
  return null;
};
exports.getProductSize = getProductSize;
const mapGroupedProducts = ({
  groupedProducts,
  productGroupingType
}) => {
  const products = (groupedProducts ?? []).filter(product => !!product?.permission?.canDisplay);
  if (productGroupingType === 'Flavour') {
    return products.map(({
      productCode,
      concept
    }) => ({
      label: concept?.flavour ? (0, _entities.decodeHTML)(concept.flavour) : productCode,
      productCode
    })).sort((a, b) => a.label.localeCompare(b.label));
  }
  return products.map(({
    productCode,
    volumeValue,
    volumeUnitText
  }) => ({
    label: getProductSize({
      volumeValue,
      volumeUnitText
    }) ?? productCode,
    productCode
  })).sort((a, b) => a.label.localeCompare(b.label));
};
exports.mapGroupedProducts = mapGroupedProducts;
const mapProductDiscontinuedAndCannotBeSold = shades => {
  if (shades.length === 0) {
    return false;
  }
  return shades.every(shade => shade.isDiscontinued && !shade.canBeSold);
};
exports.mapProductDiscontinuedAndCannotBeSold = mapProductDiscontinuedAndCannotBeSold;
const mapSubscriptionBenefitBanner = data => ({
  title: data.title ?? '',
  message: data.message ?? '',
  readMoreText: data.readMoreLink?.title ?? '',
  readMoreUrl: data.readMoreLink?.relativeUrl ?? '',
  registerText: data.registerLink?.title ?? '',
  registerUrl: data.registerLink?.relativeUrl ?? '',
  signInText: data.signInLink?.title ?? ''
});
exports.mapSubscriptionBenefitBanner = mapSubscriptionBenefitBanner;
const mapSubscription = ({
  subscription,
  isSubscriptionEnabled
}) => ({
  available: isSubscriptionEnabled && (subscription?.available ?? false),
  deliveryFrequencyOptions: [...(subscription?.allowedFrequencies ?? [])],
  recommendedFrequency: subscription?.frequency ?? 0
});
exports.mapSubscription = mapSubscription;
const mapShades = ({
  customerTypeId,
  isSubscriptionEnabled,
  shades
}) => (shades ?? []).filter(shade => shade != null).map(shade => {
  const {
    hexColors,
    imageUrl
  } = (0, _productBox.mapShade)(shade);
  const {
    deal,
    ppa
  } = (0, _productBox.mapLabels)(shade.labels) ?? {};
  return {
    // Only logged in users can reserve products, so customerTypeId will be empty or 0 for anonymous users
    canBeReserved: customerTypeId != null && customerTypeId > 0 && (0, _productBox.mapCanBeReserved)(shade.labels),
    canBeSold: (0, _productBox.mapCanBeSold)(shade.labels),
    canBeSubscribed: (0, _productBox.mapCanBeSubscribed)(shade.labels),
    isDiscontinued: shade.isDiscontinued,
    color: {
      name: shade.shadeName ?? null,
      hexColors,
      imageUrl
    },
    dealLabel: deal,
    imageUrl: shade.imageUrl ?? null,
    bonusPoints: shade.formattedPrice?.bp ?? 0,
    nextAvailableDateText: shade.productExpectedInbound?.expectedInboundLabel ?? null,
    pdpUrl: shade.pdpUrl?.relativeUrl ?? null,
    ppaLabel: ppa,
    price: {
      basicCashback: shade.formattedPrice?.price?.basicCashback ?? null,
      current: shade.formattedPrice?.price?.currentPrice ?? null,
      combinedCashback: shade.formattedPrice?.price?.combinedCashback ?? null,
      old: shade.formattedPrice?.price?.basicCataloguePrice ?? null,
      previousMinOfferPrice: shade.formattedPrice?.price?.previousMinOfferPrice ?? null,
      priceAfterImmediateDiscount: shade.formattedPrice?.price?.priceAfterImmediateDiscount ?? null
    },
    productCode: shade.productCode,
    size: getProductSize(shade),
    subscription: mapSubscription({
      isSubscriptionEnabled,
      subscription: shade.subscription
    }),
    subscriptionBenefitBanner: shade.subscriptionBenefitBanner ? mapSubscriptionBenefitBanner(shade.subscriptionBenefitBanner) : null
  };
});
exports.mapShades = mapShades;
const mapProductBase = ({
  customerTypeId,
  isSubscriptionEnabled,
  product
}) => {
  const shades = mapShades({
    customerTypeId,
    isSubscriptionEnabled,
    shades: product?.concept?.products
  });
  if (!product?.concept?.name || shades.length === 0) {
    return null;
  }
  return {
    brandName: product.concept.brand?.name ?? null,
    brandUrl: product.concept.brand?.url ?? null,
    code: product.productCode,
    name: product.concept.name,
    ratingAverage: product.concept.ratingAverage ?? 0,
    ratingCount: product.concept.ratingCount ?? 0,
    shades,
    isDiscontinuedAndCannotBeSold: mapProductDiscontinuedAndCannotBeSold(shades),
    groupedProducts: mapGroupedProducts(product)
  };
};
exports.mapProductBase = mapProductBase;
const mapProductFromGql = ({
  customerTypeId,
  isSubscriptionEnabled,
  product
}) => {
  const productBase = mapProductBase({
    customerTypeId,
    isSubscriptionEnabled,
    product
  });
  return productBase ?? null;
};
exports.mapProductFromGql = mapProductFromGql;
const mapProductsFromGql = ({
  customerTypeId,
  isSubscriptionEnabled,
  products
}) => products.map(product => product ? mapProductFromGql({
  customerTypeId,
  isSubscriptionEnabled,
  product
}) : null).filter(product => product != null);
exports.mapProductsFromGql = mapProductsFromGql;
